
import { Routes, Route, Navigate, RouteProps } from 'react-router-dom';
import { appInfo } from 'app-info';
import routes, { routesWithAuth } from 'app-routes';
import { SideNavOuterToolbar as SideNavBarLayout } from 'layouts';
import { useAuth } from 'contexts/auth';
import { Suspense } from 'react';
import { LoadPanel } from 'devextreme-react';

export const Content = () => <SideNavBarLayout title={appInfo.title}>
  <Routes>
    {routes.map(({ path, element: Element }) => <Route key={path} path={path} element={<Element/>}/>)}
    {routesWithAuth.map(({ path, element: Element }) => <Route key={path} path={path}
      element={<ProtectedRoute element={<Element/>}/>}/>)}
    <Route path="*" element={<Navigate to='/dashboard' replace={true}/>} />
  </Routes >
</SideNavBarLayout>;


export const ProtectedRoute = ({ element }: RouteProps) => {
  const { user } = useAuth();

  if (!user?.isAdmin) return <Navigate to="/home" replace />;

  return (
    <Suspense fallback={<LoadPanel />}>
      {element}
    </Suspense>
  );
};

